import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=6d40960a&scoped=true&"
import script from "./CopyButton.vue?vue&type=script&lang=js&"
export * from "./CopyButton.vue?vue&type=script&lang=js&"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=6d40960a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40960a",
  null
  
)

export default component.exports